import perfis from "./perfis";
import store from "../store";

export default [
    {
        to: "/",
        icon: "mdi-view-dashboard",
        text: "Apresentação",
    }, {
        to: "/my-projects",
        icon: "mdi-account-star",
        permission: [perfis.LOGADO],
        text: "Meus Projetos",
    }, {
        to: "/my-unit",
        icon: "mdi-account-group-outline",
        permission: [perfis.LOGADO],
        text: "Projetos da Minha Unidade",
    }, {
        to: "/auditoria",
        icon: "mdi-account-group-outline",
        permission: [perfis.AUDITOR],
        text: "Projetos da AUD",
    }, {
        to: "/projects-ufms-all",
        icon: "mdi-account-group-outline",
        permission: [perfis.ADMIN],
        text: "Projetos da UFMS",
    }, {
        to: "/comments",
        icon: "mdi-comment-eye-outline",
        permission: [perfis.ADMIN],
        text: "Comentários",
    }, {
        to: "/gerencia",
        icon: "mdi-briefcase",
        permission: [perfis.ADMIN, perfis.GERENTE],
        text: "Gerência de Projetos",
    },
    {
        to: "/compras",
        icon: "mdi-cart-outline",
        permission: [perfis.COMPRAS, perfis.ADMIN],
        text: "Compras",
    },
    {
        to: "/compras-ti",
        icon: "mdi-cart-outline",
        permission: [perfis.COMPRAS_TIC, perfis.ADMIN],
        text: "Compras de TIC",
    },
    {
        to: "/uap-inovacao",
        icon: "mdi-micro-sd",
        permission: [perfis.COMPRAS_TIC, perfis.ADMIN],
        text: "UAP - Inovação",
    },
    {
        text: "Adm [homolog]",
        permission: [perfis.HOMOLOG],
        icon: "mdi-book-open",
        subs: [
            {
                "to": "/ambiente-urls-acesso",
                text: "Acesso de Rotas do Ambiente"
            }, {
                "to": "/visao-estrategica-uac",
                text: "Visão Estratégica"
            }, {
                "to": "/agead",
                text: "AGEAD"
            }, {
                "to": "/agecom",
                text: "AGECOM"
            }, {
                "to": "/agetic",
                text: "AGETIC"
            }, {
                "to": "/agetic/projetos-disoft",
                text: "AGETIC/BI"
            }, {
                "to": "/agetic/compras",
                text: "AGETIC/Compras"
            }, {
                "to": "/agetic/projetos-dintec",
                text: "AGETIC/DINTEC"
            }, {
                "to": "/agetic/projetos-seds",
                text: "AGETIC/DISOFT"
            }, {
                "to": "/agetic/infraestruturas",
                text: "AGETIC/Infra"
            }, {
                "to": "/agetic/votacoes",
                text: "AGETIC/Votações"
            }, {
                "to": "/aginova",
                text: "AGINOVA"
            }, {
                "to": "/auditoria",
                text: "AUD/COUN"
            }, {
                "to": "/proadi",
                text: "PROADI"
            }, {
                "to": "/proaes",
                text: "PROAES"
            }, {
                "to": "/proece",
                text: "PROECE"
            }, {
                "to": "/progrep",
                text: "PROGEP"
            }, {
                "to": "/prograd",
                text: "PROGRAD"
            }, {
                "to": "/proplan",
                text: "PROPLAN"
            }, {
                "to": "/diplan",
                text: "PROPLAN/DIPLAN"
            }, {
                "to": "/propp",
                text: "PROPP"
            }
        ]
    },
   // */
    {
      text: "Ensino, Pesquisa e Extensão",
      permission: [perfis.LOGADO],
      icon: "mdi-book-open-variant",
      subs: [
          {to: "/agrotec", text: "AGROTEC"},
          {to: "/mda", text: "Apoia MDA"},
          {to: "/obcoop", text: "Obcoop"},
          {to: "/obgov",  text: "OBGOV" },
          {to: "/ufms-digital", text: "UFMS Digital"}
      ]
    }, {
        text: "Comitês [homolog]",
        permission: [perfis.HOMOLOG],
        icon: "mdi-crowd",
        subs: [
            {
                "to": "/comite-governanca-bolsas",
                text: "CGBAR"
            }, {
                "to": "/comite-logistica-sustentavel",
                text: "CGCLOS"
            }, {
                "to": "/comite-governanca-digital",
                text: "CGD"
            }, {
                "to": "/comite-espaco-fisico",
                text: "CGEFA"
            }, {
                "to": "/comite-inclusao",
                text: "CGIIAF"
            }, {
                "to": "/cgirci",
                text: "CGIRCI"
            }, {
                "to": "/comite-gestao-pessoas",
                text: "CGP"
            }
        ]
    },
    {
        text: "Planos Institucionais",
        permission: [perfis.LOGADO],
        icon: "mdi-chart-areaspline",
        subs: [
            /*{
                "to": "/acessibilidade",
                text: "Acessibilidade"
            }, {
                "to": "/comunicacao",
                text: "Comunicação"
            }, {
                "to": "/continuidade",
                text: "Continuidade de Negócios"
            }, {
                "to": "/desenvolvimento-pessoas",
                text: "Desenvolvimento de Pessoas"
            }, {
                "to": "/residuos-solidos",
                text: "Gestão de Resíduos"
            }, {
                "to": "/integridade",
                text: "Integridade"
            }, {
                "to": "/gestao-logistica-sustentavel",
                text: "Logística Sustentável"
            }, {
                "to": "/fuga",
                text: "Prevenção de Incêndios"
            }, */
            {
                "to": "/dados-abertos",
                text: "Dados Abertos"
            }, {
                "to": "/agetic/pdtic2021",
                text: "PDTIC"// deixar visivel
            }, {
                "to": "/processos-riscos",
                text: "Processos e Riscos"// deixar visivel
            }
        ]
    },
    {
        text: "Outras Ações",
        permission: [perfis.LOGADO],
        icon: "mdi-file-chart-check-outline",
        subs: [
            {
                "to": "/adequacao-lgpd",
                text: "Adequação LGPD"
            }/*, {
                "to": "/aprimoramentos-igg",
                text: "Aprimoramentos IGG"
            }, {
                "to": "/gestao-logistica-sustentavel",
                text: "Gestão de Logística Sustentável"
            }, {
                "to": "/transformagov",
                text: "TransformaGov"
            }*/, {
                "to": "/jornada/500pontos",
                text: "Jornada 500 pontos"
            }, {
                "to": "/jornada/750pontos",
                text: "Jornada 750 pontos"
            }, {
                "to": "/tratamento-de-riscos",
                text: "Tratamento de Riscos"
            }
        ]
    }/*,  todo mover
    {
        text: "Outras Ações",
        permission: [perfis.LOGADO],
        icon: "mdi-file-chart-check-outline",
        subs: [{
                "to": "/jornada/500pontos",
                text: "Jornada 500 pontos"
            }, {
                "to": "/jornada/750pontos",
                text: "Jornada 750 pontos"
            }, {
                "to": "/tratamento-de-riscos",
                text: "Tratamento de Riscos"
            }
        ]
    }*/
];
